var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"avatar",style:({ width: `${_vm.size}px`, height: `${_vm.size}px` })},[(_vm.src)?_c('img',{staticClass:"avatar__img",attrs:{"alt":_vm.alt,"src":_vm.src}}):_c('div',{staticClass:"avatar__text"},[_vm._v(_vm._s(_vm.getInitials))])])
}
var staticRenderFns = []

export { render, staticRenderFns }